module.exports = __webpack_public_path__ + "static/media/effacalar@3x.c8255c83.png";